import { Box } from '@mui/material';
import { ComponentType } from 'react';

export default function CommandPaletteRoot(props: ComponentType<typeof Box>) {
  return (
    <Box
      {...props}
      sx={{
        position: 'fixed',
        zIndex: (theme) => theme.zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        '.MuiDialog-container': {
          backgroundColor: 'transparent',
          alignItems: 'flex-start',
        },
      }}
    />
  );
}
